// @packages
import React from 'react';
import { Button } from '@rneui/themed';

// @scripts
import useStyles from './styles';

type Props = {
  color: string,
  title: string,
  onClick: () => void,
  isLoading?: boolean,
};

const Login = ({
  color, title, onClick, isLoading = false
} : Props) => {
  const styles = useStyles();

  return (
    <Button
      color={color}
      containerStyle={styles.buttonContainer}
      buttonStyle={styles.button}
      disabled={isLoading}
      loading={isLoading}
      onPress={() => onClick()}
      title={title}
      titleStyle={styles.titleStyle}
    />
  );
};

export default Login;
